"use client";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useRouter } from "next/navigation";
import { Button } from "../ui/button";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import Link from "next/link";
import { TextInput } from "../inputs/text-input";
import { toast } from "sonner";
//import axiosInstance from "@/lib/axios";
import { z } from "zod";
import { AxiosError } from "axios";
import WhatsappLinkComp from "./whatsapp-link-comp";
import AuthProcessHeader from "./auth-process-header";
import kratosClient from "@/lib/kratosClient";

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
});

// const successResponseSchema = z.object({
//   resendOtpId: z.string(),
//   message: z.string(),
// });

interface ForgotPasswordFields {
  email: string;
}

export function ForgotPasswordForm() {
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleSubmit = async (values: ForgotPasswordFields) => {
    const toastId = toast.loading("loading...", {
      position: "top-center",
      classNames: {
        title: "font-outfit font-medium relative bottom-[0.6]",
        content: "flex items-center",
      },
    });

    try {
      // Initialize the recovery flow 
      const { data: flow } = await kratosClient.get('/self-service/recovery/api')

      await kratosClient.post(
        `/self-service/recovery?flow=${flow.id}`,
        {
          email: values.email,
          method: 'code',
        }
      )

      toast.success("Check your email for instructions", { id: toastId })
      router.push(`/forgot-password/verify?email=${values.email}&flowId=${flow.id}`)

    } catch (e) {
      if (e instanceof AxiosError) {
        const data = e.response?.data
        toast.error(data?.message || "Something went wrong", { id: toastId })
      }
      if (e instanceof z.ZodError) {
        console.log("API response validation Error", e.errors)
        toast.error("Validation error occurred", { id: toastId })
      }
    }
  }

  return (
    <>
      <Formik<ForgotPasswordFields>
        validationSchema={forgotPasswordSchema}
        initialValues={{
          email: "",
        }}
        onSubmit={handleSubmit}
      >
        <Form className="w-full flex flex-col items-center justify-center gap-6 sm:gap-8 mx-auto sm:py-10 max-w-[460px]">
          <AuthProcessHeader
            heading="Reset your Password"
            subHeading="Enter the email you use for Proc360. We’ll send you a 6-digit code."
          />
          <TextInput
            name="email"
            label="Email Address"
            placeholder="Enter Email Address"
            size={isMobile ? "sm" : "lg"}
            className="my-3"
          />

          <div className="flex flex-col gap-4 w-full">
            <Button radius="full" className="w-full h-[44px]" size="lg">
              Send Code
            </Button>
            <Button radius="full" variant="outline" size="lg" className="w-full">
              <Link href="/sign-in">Back to Sign in</Link>
            </Button>
          </div>
        </Form>
      </Formik>

      <WhatsappLinkComp />
    </>
  );
}

